import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextField } from '@mui/material';
import Grid from '@mui/material/Grid2';
import CustomRadioGroup from '@ui/components/common/CustomRadioGroup';
import { FileUpload } from '@ui/components/common';
import { useTranslation } from 'react-i18next';
const options = [
    {
        label: 'Blacklist',
        value: 'blacklist'
    },
    {
        label: 'Whitelist',
        value: 'whitelist'
    }
];
const AddVehicleForm = ({ setVehicleDetails, vehicleDetails, errors, setErrors, setSelectedFile }) => {
    const { t } = useTranslation();
    const handleFileUpload = (file) => {
        if (file) {
            setSelectedFile([file]);
        }
    };
    const handleRadioChange = (event, value) => {
        setVehicleDetails({
            ...vehicleDetails,
            isBlackListed: value === 'blacklist'
        });
    };
    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'licensePlate' && errors.licensePlate) {
            setErrors((prevErrors) => ({ ...prevErrors, licensePlate: '' }));
        }
        else if (name === 'color') {
            if (/\d/.test(value)) {
                setErrors({ color: 'Color cannot contain numbers' });
            }
            else {
                setErrors({ color: '' });
            }
        }
        // } else if (name === 'model') {
        //   if (value !== '' && !/^\d+$/.test(value)) {
        //     setErrors({ model: 'Model must be numeric' });
        //   } else {
        //     setErrors({ model: '' });
        //   }
        // }
        setVehicleDetails({
            ...vehicleDetails,
            [name]: value
        });
    };
    return (_jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: 6, children: _jsx(TextField, { label: t('License#'), fullWidth: true, name: 'licensePlate', value: vehicleDetails.licensePlate, onChange: handleChange, error: !!errors.licensePlate, helperText: errors.licensePlate }) }), _jsx(Grid, { size: 6, children: _jsx(TextField, { label: t('VehicleType'), fullWidth: true, name: 'vehicleType', value: vehicleDetails.vehicleType, onChange: handleChange }) }), _jsx(Grid, { size: 6, children: _jsx(TextField, { label: t('VehicleMake'), fullWidth: true, name: 'make', value: vehicleDetails.make, onChange: handleChange }) }), _jsx(Grid, { size: 6, children: _jsx(TextField, { label: t('VehicleModel'), fullWidth: true, name: 'model', value: vehicleDetails.model, onChange: handleChange, error: !!errors.model, helperText: errors.model }) }), _jsx(Grid, { size: 6, children: _jsx(TextField, { label: t('VehicleBrand'), fullWidth: true, name: 'variant', value: vehicleDetails.variant, onChange: handleChange }) }), _jsx(Grid, { size: 6, children: _jsx(TextField, { label: t('Color'), fullWidth: true, name: 'color', value: vehicleDetails.color, onChange: handleChange, error: !!errors.color, helperText: errors.color }) }), _jsx(Grid, { size: 12, children: _jsx(CustomRadioGroup, { options: options, value: vehicleDetails.isBlackListed ? 'blacklist' : 'whitelist', handleChangeValue: handleRadioChange, alignment: 'row' }) }), _jsx(Grid, { size: 12, children: _jsx(FileUpload, { onChange: handleFileUpload, allowedFileTypes: ['PNG', 'JPG', 'JPEG', 'GIF'], allowedFileTypesText: 'PNG, JPG, JPEG, GIF', allowedFileSize: 5, uploadLabel: t('UploadFile'), multiple: false, setVehicleDetails: setVehicleDetails, vehicleDetails: vehicleDetails }) })] }));
};
export default AddVehicleForm;
